module.exports = __webpack_public_path__ + "media/images/gallery/constellations/crater/crt_names-77824bb4aa8ffb5be116d16561a80fec.gif";